// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".metrics-institution[data-v-6a616cca]{background:linear-gradient(#1e3d6f,#0e1e37);color:#fff;min-height:160px}.metrics-institution__container[data-v-6a616cca]{z-index:1}.metrics-institution__metric--narrow[data-v-6a616cca]{max-width:200px}.metrics-institution__title[data-v-6a616cca]{font-size:28px;font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
